import {QueryFunctionContext} from "@tanstack/react-query";
import {ShippingModel} from "./Models";
import ApiHttpClient from "@/HttpClient";
import {ShippingDetailModel} from "./Models/ShippingDetailModel";

export interface ShippingWithProductDetails {
    totalCount: number;
    totalPages: number;
    pageNumber: number;
    pageSize: number;
    items: ShippingDetailModel[]
}

export interface ShippingResponse extends ShippingModel {
}

export const fetchShippingDetails = async ({queryKey}: QueryFunctionContext) => {
    const [, shippingId] = queryKey;
    const {data, status, statusText} = await ApiHttpClient().get<ShippingResponse>(`/shipping/${shippingId}`);

    console.log(`Status ${status} ${statusText}`);
    console.log(JSON.stringify(data, null, 4));
    return data;
}

export const fetchShippingWithProductDetails = async ({queryKey}: QueryFunctionContext) => {
    const [, shippingId, pageNumber, pageSize] = queryKey;

    const {
        data,
        status,
        statusText
    } = await ApiHttpClient().get<ShippingWithProductDetails>(`/shippingDetail/ShippingId/${shippingId}`, {
        params: {
            pageNumber,
            pageSize,
        }
    })

    if (!data) throw new Error(`Did not receive a response, status ${status} ${statusText}`);
    return data;
}

export const fetchShippingCsvs = async ({queryKey}: QueryFunctionContext) => {
    const [, pageNumber, pageSize] = queryKey;

    const {data, status, statusText} = await
        ApiHttpClient().get<ShippingCSVListResponse>(`/shipping/csv`, {
            params: {
                pageNumber,
                pageSize,
            }
        });
    if (!data) throw new Error(`Did not receive a response, status ${status} ${statusText}`);
    return data;
};

export interface ShippingCSVListResponse {
    totalCount: number;
    totalPages: number;
    pageNumber: number;
    pageSize: number;
    items: ShippingCSVListResponseItem[];
}

export interface ShippingCSVListResponseItem {
    date: string;
    lastUpdated: string;
    workingPointId: string;
    workingPointName: string;
    shippings: number[];
    preOrders: number[];
}
